import React from 'react';
import { makeStyles } from "@mui/styles";
import { Grid, Button, Typography, IconButton, Box} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ASPECStyles from "../../../../styles/jss/components/apps/ASPECStyles";
import withRouter from '../../../../helpers/withRouter';
import { downloadData } from 'aws-amplify/storage';
import { fetchUserAttributes } from 'aws-amplify/auth';
import {downloadBlob} from "../../../../helpers";
import AnalysisOptions from "./AnalysisOptions";
import { useNavigate, useParams } from 'react-router-dom';
import SaveIcon from '@mui/icons-material/Save';

const useStyles = makeStyles(ASPECStyles);

const ASPECHeader = (props) => {

    const {data} = props;

    const classes = useStyles();
    const navigate = useNavigate();
    const params = useParams();

    const status = props.status === "SUCCESSFUL";

    const {paste, saveDraft, submit} = props.functions;

    const handleSubmit = (e) => {
        e.preventDefault();
        submit();
    }

    const listItems = () => {
        fetchUserAttributes()
            .then(attributes => {
                for(let i = 0; i < data.results.output.length; i++) {
                  downloadData({
                    key: `private/org/${attributes['custom:org']}/project/${data.results.output[i]}`,
                    options: { accessLevel: 'private' } }).result
                        .then(resp => {
                            let stringSplit = data.results.output[i].split('/');
                            downloadBlob(resp.body, stringSplit[stringSplit.length - 1])
                        })
                        .catch(e => {console.log(e)})
                }
            })

    }

    const downloadAllFiles = () => {
        listItems()
    }

    return (
        <div>
            <Grid container spacing={3} alignItems={'center'} style={{marginBottom: '10px'}}>
                <Grid size={{ md: 3 }}>
                    <Typography variant={'h5'} sx={{
                        display: 'flex',
                        alignItems: 'center',
                        alignSelf: 'center',
                        overflow: 'hidden'
                    }}>
                        <IconButton
                            disableFocusRipple
                            disableRipple
                            onClick={() => navigate('/apps/aspec-loadsgen/project/' + params.projectId)}
                            size="large">
                            <ArrowBackIcon />
                        </IconButton> Analysis Details
                    </Typography>
                </Grid>
                <Grid size={{ md: 9 }}>
                    <Box sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-end'
                    }}>
                        {status ? (
                            <>
                                <div style={{display: 'flex'}}>
                                    <Button style={{marginRight: 10}} color={'primary'} variant={'contained'} onClick={() => downloadAllFiles()}>Download Files</Button>
                                    <AnalysisOptions data={props.data} status={status} />
                                </div>
                            </>
                        ) : (
                          <>
                          <Button
                            variant="outlined"
                            style={{ marginRight: 10 }}
                            disabled={
                              // !nodePath.current ||
                              // JSON.stringify(nodeData) === JSON.stringify(savedNodeData.current) ||
                              props.isRunning
                            }
                            onClick={saveDraft}
                            loading={props.isSaving}
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                          >
                            {'SAVE'}
                          </Button>
                          <Button variant={'contained'} color={'primary'} disabled={props.runButtonDisabled || props.isSaving} onClick={(e) => handleSubmit(e)}>Run Analysis</Button>
                          <AnalysisOptions data={props.data} status={status} paste={paste} />
                      </>
                        )}



                    </Box>
                </Grid>
            </Grid>
        </div>
    );
}

export default withRouter(ASPECHeader);